'use client';

import { useEffect } from 'react';

const BodyClassesProvider = (props: { customBodyClass?: string }) => {
  const { customBodyClass } = props;

  useEffect(() => {
    if (!customBodyClass) {
      return;
    }
    if (!document.body.classList.contains(customBodyClass)) {
      document.body.classList.add(customBodyClass);
    }
  }, [customBodyClass]);

  return null;
};

export default BodyClassesProvider;
